import { ButtonComponentProps } from "./interfaces";
import { CircularProgress } from "@mui/material";

const ButtonComponent = (props: ButtonComponentProps) => {
  const {
    label,
    onClick,
    disabled,
    isLoading,
    size,
    fullWidth,
    iconStart,
    iconEnd,
    type,
    id,
    className,
  } = props;
  return (
    <button
      id={id}
      type="submit"
      disabled={disabled || isLoading}
      onClick={disabled ? undefined : (e: any) => onClick?.(e)}
      className={`${className} ${fullWidth ? "w-full" : "w-fit"} ${
        type !== "tertiary" &&
        (size?.toLowerCase() === "large"
          ? "py-3"
          : size?.toLowerCase() === "medium"
          ? "py-2"
          : "py-1.5")
      } 
         ${type.toLowerCase() !== "tertiary" ? "px-6" : "px-0"} 
      flex cursor-pointer items-center justify-center rounded-xl text-sm font-light 
       ${isLoading || iconStart || iconEnd ? "gap-3" : ""}
        ${
          disabled
            ? type.toLowerCase() === "tertiary"
              ? "cursor-not-allowed text-neutral-300 underline"
              : "cursor-not-allowed bg-neutral-50 text-neutral-300 hover:bg-neutral-50"
            : type.toLowerCase() === "primary"
            ? "bg-primary-300 text-white hover:bg-primary-400 active:border active:border-primary-200"
            : type === "secondary"
            ? "a bg-primary-100 bg-opacity-25 text-primary-300 hover:bg-primary-200 hover:bg-opacity-50 active:border active:border-primary-200"
            : type === "outline"
            ? "border border-[#AFAFAE] bg-white text-neutral-900 hover:bg-neutral-50"
            : type.toLowerCase() === "tertiary"
            ? "text-gray-600 underline hover:text-primary-300"
            : ""
        }`}
    >
      <span className="my-auto">
        {isLoading ? (
          <CircularProgress
            className={`${
              type === "secondary" ? "text-primary-300" : "text-primary-100"
            }`}
            size={"16px"}
          />
        ) : iconStart ? (
          <div>{iconStart}</div>
        ) : null}
      </span>
      <p>{label}</p>
      {iconEnd && <span className="my-auto">{iconEnd}</span>}
    </button>
  );
};

export default ButtonComponent;
